module.exports = __webpack_public_path__ + "static/media/mohit.baff6a21.gif";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/team/images/mohit.gif
// module id = 1761
// module chunks = 146